export default __webpack_public_path__ + "fonts/Jost-600-Semi.woff";